import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { removeScrollbar } from "@enkor/design/mixins";
import BaseBottomSheet from "@domains/common/views/modal/BaseBottomSheet/BaseBottomSheet";

export const BottomSheetContainer = styled(BaseBottomSheet)`
  width: 100%;
  height: fit-content;
  min-height: 270px;
  padding: 16px;
  border: 1px solid ${grayScale.main};
  border-radius: 16px 16px 0px 0px;

  background-color: ${grayScale[300]};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px 0 10px;
`;

export const Title = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const CancelButton = styled.button`
  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const TextareaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;
  padding: 24px 0 40px;
`;

export const ReportPhrase = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const ReasonTextarea = styled.textarea`
  width: 100%;
  height: 200px;
  padding: 10px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  resize: none;

  &:focus {
    border: 1px solid ${grayScale.white};
  }

  &::placeholder {
    color: ${grayScale.main};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  ${removeScrollbar}
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 13px 0;
  border-radius: 8px;

  background-color: ${pink.main};

  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  &:disabled {
    background-color: ${grayScale.main};

    color: ${grayScale[500]};

    cursor: default;
  }
`;
